// extracted by mini-css-extract-plugin
export var growableInput = "_6l-0";
export var tagContainer = "_6l-2";
export var textInput = "_6l-1";